export const errorMessages = {
  fourZeroFour: { heading: '404', description: "Sorry we can't find what your looking for" },
  entitlements: {
    heading: 'No Permissions',
    description: 'Please contact your admin to request access',
  },
};
